import Cookies from 'universal-cookie';
import { CookieTokenStore } from '@antriver/vue-site-utils/src/token-stores/CookieTokenStore';
import { Api } from '@antriver/vue-site-utils/src/classes/Api/Api';
// @ts-ignore
import config from '@/config';

const cookies = new Cookies();
export const authTokenStore = new CookieTokenStore(
    cookies,
    'sessionToken',
    '',
    '/',
    false, // cookieSecure
);

export const api = new Api(
    config.apiUrl,
    authTokenStore,
    {},
);
